// eg-collections-config-header.js
// Smart header copy config (ES5-safe)

(function () {
  window.EG_COLLECTION_HEADER_CONFIG = {
    defaults: {
      // Tokens available: {countAll}, {count}, {name}, {bits}
      defaultText: "Compare {countAll} {name} — all sizes, surfaces, and firmness levels.",
      filteredText: "{count} {name} · {bits}",

      // Which “context bits” to show when filtered (in order)
      // type:
      // - tag_prefix: reads EG tag selections matching prefix (e.g. "Firmness__Soft")
      // - literal: fixed text
      context: [
        { type: "tag_prefix", prefix: "Surface Type__", label: "" },
        { type: "tag_prefix", prefix: "P-Size__", label: "" },
        { type: "tag_prefix", prefix: "Firmness__", label: "" },
        { type: "literal", text: "In stock first" }
      ],

      // How to format multiple selections for a given prefix:
      // - "list": "A / B / C"
      // - "range": "A–C" (first/last using order if provided)
      multiMode: "list",

      // Optional per-prefix ordering for "range" mode
      orders: {
        // Example:
        // "P-Size__": ["S","M","L","XL","XXL"]
      }
    },

    collections: {
      "gaming-mousepads": {
        defaultText: "Compare {countAll} mousepads — all sizes, surfaces, and firmness levels.",
        filteredText: "{count} mousepads · {bits}",

        // Example: show “Control” / “XL–XXL” / “Soft” etc
        context: [
          { type: "tag_prefix", prefix: "Surface Type__", label: "" },
          { type: "tag_prefix", prefix: "P-Size__", label: "" },
          { type: "tag_prefix", prefix: "Firmness__", label: "" },
          { type: "literal", text: "In stock first" }
        ],

        // Make size show like XL–XXL if multiple are selected
        multiMode: "range",
        orders: {
          "P-Size__": ["S", "M", "L", "XL", "XXL", "3XL"]
        }
      }
    }
  };
})();
